import { Offers } from '@contexts/AppContext';
import { ClickTarget } from '@tracking';
import { User } from '@utils/backend-api/currentUser';

export interface NewsletterActionProps {
  accessLevel: number;
  afterSignUpUrl?: string;
  currentUserSubscribed: boolean;
  description: string;
  hasPublishedArticles: boolean;
  id: number;
  isPro: boolean;
  isSubscriberOnly: boolean;
  name: string;
  offers?: Offers;
  readLatestPath: string;
  updateNewsletterSubscription: (id: number, subscribed: boolean) => void;
}

export type RenderButtonProps = {
  as: 'button' | 'link';
  customClassName?: string;
  href?: string;
  onClick?: () => void;
  onClickCapture?: (clickTarget: ClickTarget, lable: string) => void;
  icon: React.ReactNode;
  label: string;
  textColor?: string;
  clickTarget?: ClickTarget;
};

export interface NewsletterActionButtonProps {
  afterSignUpUrl?: string;
  canSubscribeToNewsletter: boolean;
  currentUserSubscribed: boolean;
  id: number;
  initialCurrentUser: User;
  isCurrentlySubscriber?: boolean;
  isNewsletterLanding?: boolean;
  isPersonalizedBriefing?: boolean;
  isPro?: boolean;
  isProSubscriber?: boolean;
  newsletterName?: string;
  offers?: Offers;
  onClickCapture: (ClickTarget: ClickTarget, label: string) => void;
  toggleModal?: () => void;
  redirectToAfterSubscribe?: string;
  updateStateHandlerOnSubscribe?: () => void;
  updateStateHandlerOnUnsubscribe?: () => void;
}

export const DEFAULT_PRO_SUBSCRIBE_OFFER_CODE = 'pro-disc25';
export const READ_THE_LATEST = 'Read the latest';
export const FEATURES = 'features';
export const UNSUBSCRIBE = 'Unsubscribe';
export const SUBSCRIBERS_ONLY = 'Subscribers only';
export const PRO_SUBSCRIBERS_ONLY = 'Pro subscribers only';
export const SIGN_UP = 'Sign up';
export const SIGN_UP_FOR_ALL = 'Sign up for all';
export const NEWSLETTER_LEAD = 'newsletter_lead';
export const NEWSLETTER_EN_LANGUAGE = 'en';
export const EMAIL = 'email';
export const SIGN_IN = 'Sign in';
export const SHARE = 'Share';
export const ARCHIVES = 'Archives';
export const PERSONALIZED_BRIEFING = 'Personalized Briefing';
